import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function transcriptionToChatMessage(textStream, room) {
    return {
        id: textStream.streamInfo.id,
        timestamp: textStream.streamInfo.timestamp,
        type: 'chatMessage', // <-- required
        message: textStream.text,
        from: textStream.participantInfo.identity === room.localParticipant.identity
            ? room.localParticipant
            : Array.from(room.remoteParticipants.values()).find((p) => p.identity === textStream.participantInfo.identity),
    };
}
